module.exports = __webpack_public_path__ + "assets/206d38f6586ef9341b81e7030cdadb82.svg";